import { Box, CircularProgress } from "@mui/material"
const MuiSpinner = () => {
    return (
      <Box sx={{ display: 'flex',justifyContent:'center', alignItems:'center',height : '95vh' }}>
        <CircularProgress />
      </Box>
    )
}
export default MuiSpinner;